import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <img src="/images/logo.png" alt="LW&Co Building Company" className="w-[190px] h-auto" data-testid="footer-logo" />
          <p className="mt-5 text-sm text-white/50 leading-relaxed max-w-xs">
            LW&Co Building Company Limited. Exceptional residential and commercial builds across the Wairarapa since 2017.
          </p>
        </div>
        <div>
          <div className="text-[11px] font-bold uppercase tracking-[0.25em] text-gold mb-5">Explore</div>
          <div className="space-y-3">
            {[["Home", "/"], ["Our Builds", "/our-builds"], ["Our Plans", "/our-plans"], ["About", "/about"], ["Meet the Team", "/team"], ["Careers", "/careers"], ["Contact", "/contact"]].map(([label, to]) => (
              <Link key={to} to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
                className="block text-sm text-white/60 hover:text-gold transition-colors w-fit">{label}</Link>
            ))}
          </div>
        </div>
        <div>
          <div className="text-[11px] font-bold uppercase tracking-[0.25em] text-gold mb-5">Contact</div>
          <p className="text-sm text-white/60">Masterton, Wairarapa, New Zealand</p>
          <p className="text-sm text-white/60 mt-2">admin@lwandco.co.nz · 027 222 5926</p>
          <a href="https://www.instagram.com/lwandco" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link"
            className="mt-4 inline-flex items-center gap-2 text-sm text-white/60 hover:text-gold transition-colors">
            <Instagram size={15} /> @lwandco
          </a>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-7 border-t border-white/10 flex flex-wrap items-center justify-between gap-4">
        <span className="text-[11px] uppercase tracking-[0.2em] text-white/35">
          © {new Date().getFullYear()} LW&Co Building Company Limited
        </span>
        <Link to="/admin/login" data-testid="footer-admin-link"
          className="text-[11px] uppercase tracking-[0.2em] text-white/35 hover:text-gold transition-colors">
          Admin
        </Link>
      </div>
    </footer>
  );
}
